import { render, staticRenderFns } from "./CategoryTemplate.vue?vue&type=template&id=17486eb0&scoped=true"
import script from "./CategoryTemplate.vue?vue&type=script&lang=js"
export * from "./CategoryTemplate.vue?vue&type=script&lang=js"
import style0 from "./CategoryTemplate.vue?vue&type=style&index=0&id=17486eb0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17486eb0",
  null
  
)

export default component.exports